module.exports = __webpack_public_path__ + "media/images/sprite-feedback-208f34b2e1f8a33f27d99f39e399b4f7.svg";